import React, { Fragment, useState } from 'react';
import { compose } from 'recompose';
import { reduxForm, getFormValues, Field } from 'redux-form';
import { connect } from 'react-redux';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';

import { 
    TextInput, 
    SelectInput,
    AddButton,
    Modal,
    CardElement,
} from '../../_Components';
import { UPDATE, CREATE, DELETE, provider, history, confirm } from '../../_utils';

const pad2 = (value) => String(value).padStart(2, '0');

const formatCardDate = (value) => {
    if (!value) {
        return '—';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '—';
    }
    const now = new Date();
    const time = `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
    const sameDay = (a, b) => (
        a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate()
    );
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (sameDay(date, now)) {
        return `сегодня, ${time}`;
    }
    if (sameDay(date, yesterday)) {
        return `вчера, ${time}`;
    }
    const dayMonth = `${pad2(date.getDate())}.${pad2(date.getMonth() + 1)}`;
    if (date.getFullYear() === now.getFullYear()) {
        return dayMonth;
    }
    return `${dayMonth}.${date.getFullYear()}`;
};

const NewCardForm = ({isSaving, ...props}) => {
    const comboboxesId = [];
    const options = [];
    props.fields && props.fields.map( f=> f.type==="select" && comboboxesId.push(f.combobox));
    (props.comboboxes || []).map( c => options.push({id: c._id, name: c.name}));
    return(
        <div className="pc-fgrid">
                <div className="pc-f--full">
                    <Field
                        name="name"
                        label={`Название`}
                        disabled={isSaving}
                        component={TextInput}
                    />
                </div>
                <Field
                    name="task"
                    label={`Тема`}
                    options={options}
                    disabled={isSaving}
                    component={SelectInput}
                />
                <Field
                    name="result"
                    label={`Результат`}
                    options={options}
                    disabled={isSaving}
                    component={SelectInput}
                />
        </div>
    )
}

const dictName = (combobox, id) => {
    if (!id) {
        return '';
    }
    const item = (combobox || []).find((option) => String(option._id) === String(id));
    return item ? item.name : '';
};

const List = ({cards, copyCard, deleteCard, openCard, goToCard, combobox}) => {
    const [menu, setMenu] = useState({ el: null, id: null });

    return (
        <>
        <table className="pc-cards-tbl">
            <thead>
                <tr>
                    <th style={{ width: '26%' }}>Название</th>
                    <th style={{ width: '16%' }}>Тема</th>
                    <th style={{ width: '16%' }}>Результат</th>
                    <th className="num" style={{ width: '11%' }}>Шагов</th>
                    <th style={{ width: '14%' }}>Обновлена</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {cards.map((card) => (
                    <tr key={card._id} className={menu.id === card._id ? 'is-cur' : ''}>
                        <td>
                            <button type="button" className="nm" onClick={() => goToCard(card._id)}>
                                {card.name}
                            </button>
                        </td>
                        <td>{dictName(combobox, card.task)}</td>
                        <td>{dictName(combobox, card.result)}</td>
                        <td className="num">{card.oldScript || card.steps || '—'}</td>
                        <td className="when">{formatCardDate(card.updatedAt || card.updated || card.modified)}</td>
                        <td className="act">
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<ContentCopyIcon sx={{ fontSize: '14px !important' }} />}
                                onClick={() => copyCard(card._id)}
                            >
                                Дублировать
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                startIcon={<OpenInBrowserIcon sx={{ fontSize: '14px !important' }} />}
                                onClick={() => openCard(card._id)}
                                style={{ marginLeft: 6 }}
                            >
                                Открыть
                            </Button>
                            <IconButton
                                size="small"
                                style={{ marginLeft: 6 }}
                                onClick={(event) => setMenu({ el: event.currentTarget, id: card._id })}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        <Menu
            anchorEl={menu.el}
            open={Boolean(menu.el)}
            onClose={() => setMenu({ el: null, id: null })}
        >
            <MenuItem
                onClick={() => {
                    const id = menu.id;
                    setMenu({ el: null, id: null });
                    deleteCard(id);
                }}
                sx={{ color: 'var(--danger)' }}
            >
                <DeleteOutlineIcon sx={{ fontSize: 16, mr: 1 }} />
                Удалить
            </MenuItem>
        </Menu>
        </>
    );
};

const Cards = ({ classes, formValues, change, ...props }) => {
    const [newCard, setNewCard] = useState(false);
    const [copyCardId, setCopyCardId] = useState(null);
    const [query, setQuery] = useState('');
    if (!formValues) {
        return null;
    }
    const cards = formValues.cards || [];
    const combobox = formValues.combobox || [];
    const fields = formValues.fields || [];
    
    const goToCard = (id) => {
        history.push('/cards/'+id)
    };

    const copyCard = (id) => {
        setNewCard(!newCard);
        setCopyCardId(id)
    }

    const deleteCard = (id) => {
        const card = cards.find((item) => item._id === id);
        confirm({
            title: 'Удалить карточку?',
            message: `Карточка «${card && card.name ? card.name : id}» будет удалена. Это действие нельзя отменить.`,
            confirmLabel: 'Удалить',
            onConfirm: async () => {
                const { status } = await provider(DELETE, '/cards', id);
                if (status === 200) {
                    change('cards', cards.filter((item) => item._id !== id));
                }
            }
        });
    }

    const openCard = (id) => {
        window.open('http://card.profcontact.by/'+id, '_blank', 'noopener,noreferrer');
    }

    const open = () => {
        setNewCard(!newCard);
    }

    const save = async (card) => {
        if(card){
            let newCard = {...card, project: formValues._id};
            if(copyCardId){
                const oldCard = (formValues.cards || []).find( c => c._id === copyCardId);
                newCard = { ...oldCard, ...card };
                delete newCard._id;
            }
            const { status, data } = await provider(
                CREATE,
                '/cards',
                { data: newCard }
            );
            if(status===200 && data){
                change('cards', [...cards, data]);
                await provider(
                    UPDATE,
                    '/projects',
                    {  id: formValues._id,
                        data: { ...formValues, cards: [...cards, data] }
                    }
                );
                setNewCard(!newCard);
                setCopyCardId(null);
            }
        }
    }

    const q = query.trim().toLowerCase();
    const visible = q
        ? cards.filter((card) => String(card.name || '').toLowerCase().includes(q))
        : cards;

    return (
        <Fragment>
        <div className="pc-fill">
        <CardElement
            fill
            content={
                <div className="pc-panel-body">
                    <div className="pc-toolbar">
                        <TextField
                            className="pc-search"
                            size="small"
                            placeholder="Поиск карточки"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ fontSize: 16, color: 'var(--muted-2)' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <span className="pc-rescount">{visible.length} карточек</span>
                        <AddButton
                            label={'Новая карточка'}
                            handleAddClick={open}
                            variant="contained"
                            style={{ marginLeft: 'auto' }}
                        />
                    </div>
                    <div className="pc-tblwrap">
                    <List cards={visible} goToCard={goToCard} copyCard={copyCard} deleteCard={deleteCard} openCard={openCard} combobox={combobox} />
                    </div>
                </div>
            }
        />
        </div>
            {newCard&&
                <Modal 
                    width={520}
                    title="Добавить карточку"
                    open={newCard} 
                    handleSaveClick={save} 
                    handleCloseClick={open} 
                    fields={<NewCardForm classes={classes} comboboxes={combobox} fields={fields} {...props}/>} 
                />
            }
        </Fragment>
    );
}

const mapStateToProps = (state, props) => {
    const formValues = getFormValues('project')(state);
    return { 
        formValues
    }
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'project',
        destroyOnUnmount: false, // <------ preserve form data
        forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    }),
);

export default enhance(Cards);;